export enum DocumentSearchFacetType {
    filename = "DOCUMENT_PROPERTY_FILENAME",
    title = "DOCUMENT_PROPERTY_TITLE",
    culture = "DOCUMENT_PROPERTY_CULTURE_CODE",
    range = "RANGE",
    meta = "META",
    fund = "FUND",
    account = "ACCT",
    class = "CLSS",
}